import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

/**
 * @param {string} title
 * @param {Array<{ question: string, answer: string }>} items
 * @param {string} [className] — extra section classes (e.g. pt-16)
 */
const ProductFAQAccordion = ({ title, items, className = '' }) => {
  return (
    <section className={`bg-white px-4 pb-20 ${className}`.trim()}>
      <div className="mx-auto max-w-4xl">
        <h2 className="text-center text-3xl font-bold text-gray-900">{title}</h2>
        <Accordion type="single" collapsible className="mt-8 space-y-3">
          {items.map((item, index) => (
            <AccordionItem
              key={item.question}
              value={`faq-${index}`}
              className="overflow-hidden rounded-xl border border-gray-200 border-b-0 bg-white px-1 data-[state=open]:shadow-sm"
            >
              <AccordionTrigger className="px-4 py-4 text-left text-base font-semibold text-gray-900 hover:text-blue-900 hover:no-underline [&[data-state=open]]:text-blue-900 [&>svg]:text-blue-800/70">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="px-4 text-sm leading-relaxed text-gray-600">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default ProductFAQAccordion;
